import React from 'react';
import { useNavigate } from 'react-router-dom';
import { APPS, appUrl } from '../config/apps';

export default function Launcher() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const token = localStorage.getItem('token');

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
  };

  const openApp = (app) => {
    if (!app.enabled) return;
    // External apps (not CLTS internal): just open in a new tab, no SSO token handoff.
    if (app.external) {
      window.open(appUrl(app), '_blank', 'noopener,noreferrer');
      return;
    }
    // Token-passing SSO: hand the JWT + user payload to the target app's /sso route.
    const payload = btoa(encodeURIComponent(JSON.stringify(user)));
    const url = `${appUrl(app)}/sso?token=${encodeURIComponent(token)}&u=${payload}`;
    window.location.href = url;
  };

  // Filter tiles by the user's app allowlist.
  // ADMIN sees all; blank allowlist = all (grandfather); otherwise only listed apps.
  const userApps = (user.apps || '').split(',').map(s => s.trim()).filter(Boolean);
  const isAdmin = user.role === 'ADMIN';
  const visibleApps = APPS.filter(a => isAdmin || userApps.length === 0 || userApps.includes(a.key));

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)', color: '#fff' }}>
      {/* Top bar */}
      <div style={{
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        padding: '18px 32px', borderBottom: '1px solid rgba(255,255,255,0.1)'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <span style={{ fontSize: 22 }}>🚀</span>
          <div>
            <div style={{ fontSize: 18, fontWeight: 700 }}>CLTS Portal</div>
            <div style={{ fontSize: 11, color: '#94a3b8' }}>Application Launcher</div>
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <div style={{ textAlign: 'right' }}>
            <div style={{ fontSize: 13, fontWeight: 600 }}>{user.fullName || user.username}</div>
            <div style={{ fontSize: 11, color: '#94a3b8' }}>{user.role}</div>
          </div>
          <button onClick={logout} style={{
            padding: '8px 16px', background: 'rgba(255,255,255,0.1)', color: '#e2e8f0',
            border: 'none', borderRadius: 8, fontSize: 13, cursor: 'pointer'
          }}>Logout</button>
        </div>
      </div>

      {/* Greeting */}
      <div style={{ textAlign: 'center', padding: '48px 20px 32px' }}>
        <h1 style={{ fontSize: 28, fontWeight: 700 }}>Welcome, {user.fullName || user.username} 👋</h1>
        <p style={{ fontSize: 15, color: '#94a3b8', marginTop: 8 }}>Choose an application to continue</p>
      </div>

      {/* Launcher grid */}
      <div style={{
        display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 240px))',
        gap: 24, justifyContent: 'center', padding: '0 32px 60px', maxWidth: 900, margin: '0 auto'
      }}>
        {visibleApps.map(app => (
          <div key={app.key}
            onClick={() => openApp(app)}
            style={{
              background: app.enabled ? 'rgba(255,255,255,0.06)' : 'rgba(255,255,255,0.03)',
              border: '1px solid rgba(255,255,255,0.1)', borderRadius: 16, padding: 28,
              textAlign: 'center', cursor: app.enabled ? 'pointer' : 'not-allowed',
              opacity: app.enabled ? 1 : 0.45, transition: 'all 0.18s', position: 'relative'
            }}
            onMouseEnter={e => { if (app.enabled) { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.background = 'rgba(255,255,255,0.1)'; } }}
            onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.background = app.enabled ? 'rgba(255,255,255,0.06)' : 'rgba(255,255,255,0.03)'; }}
          >
            <div style={{
              width: 64, height: 64, borderRadius: 16, margin: '0 auto 16px',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 32, background: app.color + '22', border: `1px solid ${app.color}55`
            }}>{app.icon}</div>
            <div style={{ fontSize: 16, fontWeight: 700 }}>{app.name}</div>
            <div style={{ fontSize: 12, color: '#94a3b8', marginTop: 6, lineHeight: 1.5 }}>{app.description}</div>
            {!app.enabled && (
              <div style={{
                position: 'absolute', top: 12, right: 12, fontSize: 10, fontWeight: 600,
                background: 'rgba(255,255,255,0.12)', color: '#cbd5e1', padding: '2px 8px', borderRadius: 20
              }}>Coming soon</div>
            )}
            {app.enabled && app.external && (
              <div style={{
                position: 'absolute', top: 12, right: 12, fontSize: 10, fontWeight: 600,
                background: 'rgba(255,255,255,0.12)', color: '#cbd5e1', padding: '2px 8px', borderRadius: 20
              }}>↗ New tab</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
